/* Traveler's Choice navigation redesign, phase P2 (shopify-theme #559): desktop bar behavior.
   UMD: module.exports in Node (tests/nav/tc-nav-bar.test.js), window.TCNavBar in the
   browser, where it wires itself once.

   (Section 1 was the wishlist trigger, contract K5, which opened Swym's wishlist. It went
   when Swym was uninstalled, #633.)
   2. Cart name. The visible count badge is aria-hidden; the cart link's name comes from
      a visually hidden span, "Cart, 2 items". theme.js (Totals) rewrites only the numbers
      on theme:cart:change, so this rewrites the span from the same event.
   3. Fit guard. assets/tc-nav-bar.css picks the bar's spacing and whether the shortcut
      items show from the window width, which fits today's labels with room to spare
      (measured). A longer promo title typed in the theme editor could still overflow,
      so after load, after fonts arrive, on resize and when the bar's centre box changes
      size (a ResizeObserver, where the browser has one) this checks the bar and, only if
      it overflows, steps down: compact spacing first, then the shortcut items leave. It
      never touches theme.js or the hamburger switch. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.TCNavBar = api;
    api.init(root.document, root);
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var LEVEL_CLASSES = ['tc-nav--compact', 'tc-nav--no-shortcuts'];

  // ---- 2. Cart name ----
  function cartName(label, count, one, other) {
    var n = Math.max(0, Math.floor(Number(count) || 0));
    return label + ', ' + n + ' ' + (n === 1 ? one : other);
  }

  function syncCartName(doc, count) {
    var spans = doc.querySelectorAll('[data-tc-cart-name]');
    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      span.textContent = cartName(
        span.getAttribute('data-label') || '',
        count,
        span.getAttribute('data-one') || '',
        span.getAttribute('data-other') || ''
      );
    }
    return spans.length;
  }

  // ---- 3. Fit guard ----
  // tryLevel(i) applies level i and returns true when the bar still overflows.
  // Returns the first level that fits, or the last level when none does.
  function fitLevel(tryLevel, levels) {
    for (var i = 0; i < levels; i++) {
      if (!tryLevel(i)) return i;
    }
    return levels - 1;
  }

  function overflows(desktop) {
    if (!desktop || !desktop.getClientRects().length) return false;
    return desktop.scrollWidth > desktop.clientWidth + 1;
  }

  function fitBar(wrapper) {
    if (!wrapper) return -1;
    var desktop = wrapper.querySelector('[data-header-desktop]');
    return fitLevel(function (level) {
      for (var i = 0; i < LEVEL_CLASSES.length; i++) {
        if (i < level) wrapper.classList.add(LEVEL_CLASSES[i]);
        else wrapper.classList.remove(LEVEL_CLASSES[i]);
      }
      return overflows(desktop);
    }, LEVEL_CLASSES.length + 1);
  }

  function init(doc, win) {
    if (!doc || doc.__tcNavBarBound) return false;
    doc.__tcNavBarBound = true;
    doc.addEventListener('theme:cart:change', function (event) {
      var cart = event && event.detail && event.detail.cart;
      if (cart) syncCartName(doc, cart.item_count);
    });
    var pending = false;
    var observer = null;
    var observed = null;
    // A layout change after load with no window resize (a text-spacing or font-size
    // override, WCAG 1.4.12) also changes the size of the bar's centre box, so a
    // ResizeObserver on it re-fits the bar. Each run looks the box up again, so a header
    // the theme editor re-renders is followed. Browsers without ResizeObserver keep the
    // load, font and resize triggers.
    var watch = function (wrapper) {
      var centre = observer && wrapper ? wrapper.querySelector('.header__desktop__bar__c') : null;
      if (!centre || centre === observed) return;
      if (observed) observer.unobserve(observed);
      observer.observe(centre);
      observed = centre;
    };
    var run = function () {
      pending = false;
      var wrapper = doc.querySelector('[data-header-wrapper]');
      fitBar(wrapper);
      watch(wrapper);
    };
    var schedule = function () {
      if (pending) return;
      pending = true;
      if (typeof win.requestAnimationFrame === 'function') win.requestAnimationFrame(run);
      else win.setTimeout(run, 0);
    };
    if (typeof win.ResizeObserver === 'function') observer = new win.ResizeObserver(schedule);
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', schedule);
    else schedule();
    win.addEventListener('load', schedule);
    win.addEventListener('resize', schedule);
    if (doc.fonts && doc.fonts.ready && typeof doc.fonts.ready.then === 'function') doc.fonts.ready.then(schedule);
    return true;
  }

  return {
    LEVEL_CLASSES: LEVEL_CLASSES,
    cartName: cartName,
    syncCartName: syncCartName,
    fitLevel: fitLevel,
    fitBar: fitBar,
    init: init
  };
}));
